import styled from 'styled-components';

export const DisabledLink = styled.span`
	color: #999;
	cursor: not-allowed;
`;

export default DisabledLink;
